const delayShowPrice = () => {
    setTimeout(() => {
        BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartMutate', 'CartPriceMutate');
    }, 3000);
}

delayShowPrice();

const customCustomField = (customFieldValue) => {
    const invoiceTypeInput = document.querySelectorAll(`.nu-invoice__type input[name="nu_invoice_type"]`);
    const invoiceLabel = document.querySelector(`.nu-invoice__type legend.custom-field-label`);
    let invoiceType = "";
    invoiceTypeInput.forEach(input => {
        if (input.checked) {
            invoiceType = input.value;
            customFieldValue.push({ key: invoiceLabel.innerText, value: input.value });
        };
    })
    const appSelect = document.querySelector("select#app-select");
    const appSelectLabel = document.querySelector(`#row-application label[for="app-select"]`);
    if (appSelect) customFieldValue.push({ key: (appSelectLabel?.innerText || "Application")?.replace(" *", ""), value: appSelect.value });
    const iecInput = document.querySelector("textarea#iec-input");
    if (iecInput) customFieldValue.push({ key: "IEC.No", value: iecInput.value });
    const vatInput = document.querySelector("textarea#vat-input");
    if (vatInput) customFieldValue.push({ key: "VAT No", value: vatInput.value });
    const clearanceType = document.querySelectorAll(`#row-customs .custom-radio-group input.custom-radio-req`);
    const clearanceLabel = document.querySelector("#row-customs label.custom-field-label");
    clearanceType.forEach(input => {
        if (input?.checked) customFieldValue.push({ key: (clearanceLabel.innerText)?.replace(" *", ""), value: input.value });
    })
    customFieldValue.push({ key: "Privacy Policy Agreed Time", value: new Date().toISOString() });
    customFieldValue.push({ key: "Due Diligence Agreed Time", value: new Date().toISOString() });
    if (invoiceType === "company") {
        const taxIdInput = document.querySelector("#nu-invoice-tax-id");
        const taxIdLabel = document.querySelector(`label[for="nu-invoice-tax-id"]`);
        if (taxIdInput) customFieldValue.push({ key: (taxIdLabel?.innerText || "公司統編").replace(" *", ""), value: taxIdInput.value });
        const companyTitle = document.querySelector("#nu-invoice-company-title");
        const companyTitleLabel = document.querySelector(`label[for="nu-invoice-company-title"]`);
        if (companyTitle) customFieldValue.push({ key: (companyTitleLabel?.innerText || "公司抬頭").replace(" *", ""), value: companyTitle.value });
    }
    customFieldValue = customFieldValue.filter(item => item.value);
    return customFieldValue;
}

window?.BSS_B2B?.custom?.addFilter?.('custom:order_additional_details/checkout', customCustomField);

const lockToTaiwanOnly = (select) => {
    if (!select) return;
    const twOption = Array.from(select.options).find(o =>
        o.value === 'TW' || o.textContent.trim().toLowerCase() === 'taiwan'
    );
    if (!twOption) return;
    Array.from(select.options).forEach(o => { if (o !== twOption) o.remove(); });
    if (select.value !== 'TW') {
        twOption.selected = true;
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }
};

const findAndLockAll = (root = document) => {
    root.querySelectorAll('select#countryCode, select[name*="country" i], select[id*="country" i]')
        .forEach(lockToTaiwanOnly);
    root.querySelectorAll('*').forEach(el => {
        if (el.shadowRoot) {
            findAndLockAll(el.shadowRoot);
            observeRoot(el.shadowRoot); 
        }
    });
};

const observedRoots = new WeakSet();
const observeRoot = (root) => {
    if (observedRoots.has(root)) return; 
    observedRoots.add(root);
    const mo = new MutationObserver(() => findAndLockAll(root));
    mo.observe(root, { childList: true, subtree: true });
};

observeRoot(document);
findAndLockAll();